import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-272">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-273" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-6" data-id="element-274">
        ¿Cuánto Cuesta Todo Esto?
      </h2>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-275">
        Ahora, quizás pienses que una colección tan completa como esta será
        extremadamente cara...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-276">
        ...y la verdad es que <strong data-id="element-277">debería serlo</strong>, considerando el
        inmenso valor que cientos de familias están obteniendo de este pack.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-278">
        Por supuesto, cuando una sola sesión con un especialista en estimulación
        temprana cuesta entre 30 € y 60 € por hora, y un curso online mediocre
        cobra 97 € o más, es natural pensar que un paquete con{' '}
        <strong data-id="element-279">más de 1.000 actividades</strong> y años de trabajo invertido
        podría ser inasequible.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-280">
        Sin embargo, <strong data-id="element-281">¡no lo es!</strong>
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-282">
        Sentí que era mi deber hacer el Pack Estimulación Temprana accesible
        para TODAS las familias, así que ofrezco un descuento especial de
        lanzamiento por tiempo limitado...
      </p>

      <div className="text-center my-8" data-id="element-283">
        <p className="font-serif text-lg text-body-text mb-2" data-id="element-284">
          Así que para celebrar este lanzamiento... el precio será solo
        </p>
        <p data-id="element-285">
          <PriceDisplay amount={36} className="font-sans text-2xl line-through text-gray-400" data-id="element-286" />
          <span className="mx-3" data-id="element-287"></span>
          <PriceDisplay amount={12.99} className="font-sans text-4xl md:text-5xl font-black text-primary" data-id="element-288" />
        </p>
      </div>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-289">
        <strong data-id="element-290">Así es.</strong> Tu inversión por el pack completo es de solo{' '}
        <span className="text-primary font-bold text-xl" data-id="element-291">
          <PriceDisplay amount={12.99} data-id="element-292" />
        </span>
        .
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-293">
        Eso es{' '}
        <span className="highlight" data-id="element-294">
          toda una vida de actividades de estimulación al precio de un par de
          cafés
        </span>
        .
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-295">
        Pero déjame advertirte:{' '}
        <strong data-id="element-296">esta oferta especial de lanzamiento se cerrará pronto</strong> y
        no podrás acceder a este precio después, aunque quieras.
      </p>
      <p className="font-serif text-lg text-body-text mb-8 leading-relaxed" data-id="element-297">
        Una vez que reciba más testimonios, subiré el precio. Primero a 19,99
        €... luego a 36,00 € y más... y seguirá siendo una ganga por lo que
        recibes.
      </p>

      {/* Main Price Box with Value Stack */}
      <div className="bg-gradient-to-br from-[#FFF8E1] to-highlight-bg border-[3px] border-accent rounded-2xl py-9 px-6 md:px-8 text-center my-10" data-id="element-298">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark mb-6" data-id="element-299">
          Esto Es TODO Lo Que Recibes:
        </h2>

        <div className="text-left max-w-lg mx-auto font-sans text-base leading-loose mb-4" data-id="element-300">
          <p className="flex justify-between items-start py-1" data-id="element-301">
            <span data-id="element-302">
              Acceso Inmediato a +1.000 Actividades paso a paso, mes a mes...
            </span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-303">
              (Valor: <PriceDisplay amount={36} data-id="element-304" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-305">
            <span data-id="element-306">Guías PDF Imprimibles para todas las edades</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-307">
              (Valor: Incluido)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-308">
            <span data-id="element-309">Cobertura de 6 Áreas de Desarrollo Completas</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-310">
              (Valor: Incluido)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-311">
            <span data-id="element-312">Garantía de Satisfacción 100% Sin Riesgo</span>
            <span className="text-green-dark font-bold ml-4" data-id="element-313">✅</span>
          </p>
        </div>

        <p className="font-sans font-bold text-dark mt-6 mb-3" data-id="element-314">
          Más Estos Bonos Increíbles:
        </p>

        <div className="text-left max-w-lg mx-auto font-sans text-base leading-loose mb-4" data-id="element-315">
          <p className="flex justify-between items-start py-1" data-id="element-316">
            <span data-id="element-317">🧩 10 Juegos Montessori</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-318">
              (Valor: <PriceDisplay amount={15} data-id="element-319" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-320">
            <span data-id="element-321">🎨 Tarjetas de Alto Contraste Imprimibles</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-322">
              (Valor: <PriceDisplay amount={10} data-id="element-323" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-324">
            <span data-id="element-325">🥑 Alimentación BLW Segura</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-326">
              (Valor: <PriceDisplay amount={12} data-id="element-327" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-1" data-id="element-328">
            <span data-id="element-329">😤 10 Claves Para Gestionar Rabietas</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-330">
              (Valor: <PriceDisplay amount={12} data-id="element-331" />)
            </span>
          </p>
        </div>

        <div className="font-sans text-lg font-bold border-t-2 border-accent pt-4 mt-4 text-dark" data-id="element-332">
          Valor Total:{' '}
          <span className="text-primary text-2xl" data-id="element-333">
            <PriceDisplay amount={85} data-id="element-334" />
          </span>
        </div>

        <p className="font-sans text-lg mt-6 text-gray-600" data-id="element-335">
          Consíguelo Todo Por Un Pago Único De:
        </p>

        <div className="my-4" data-id="element-336">
          <PriceDisplay amount={36} className="font-sans text-2xl md:text-3xl line-through text-gray-400 block" data-id="element-337" />
          <PriceDisplay amount={12.99} className="font-sans text-5xl md:text-6xl font-black text-primary" data-id="element-338" />
        </div>

        <p className="font-sans text-sm text-gray-500 mb-6" data-id="element-339">
          (Esta es una oferta especial de lanzamiento. Me reservo el derecho de
          cerrar este descuento en cualquier momento sin previo aviso después
          del 25 de febrero de 2026)
        </p>

        <div className="my-6" data-id="element-340">
          <CtaButton size="large" subtitle="Acceso Inmediato a +1.000 Actividades >>" data-id="element-341">
            Añadir Al Carrito
          </CtaButton>
        </div>

        <p className="font-sans text-sm text-gray-500" data-id="element-342">
          Pago único. Sin cuotas mensuales. Sin cargos ocultos.
        </p>
      </div>
    </div>;
}